import './styles/sectionMap.css'
import { useEffect, useState } from 'react'
import getIp from '../functions/getIp'
import Mapa from './Map'

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';

import { defaults } from 'ol/control'
import {fromLonLat} from 'ol/proj';



export default props => {
    const [state, setState] = useState({
        ip: 'n/a',
        ipReverso: 'n/a',
        cidade: 'n/a',
        estado: 'n/a',
        pais: 'n/a',
        provedora: 'n/a',
        lon: 'n/a',
        lat: 'n/a'
    })

    const setInfos = async () => {
        const infos = await getIp()
        const estado = infos.region.split(' ')[2]

        setState({
            ip: infos.ip,
            ipReverso: infos.reverse,
            cidade: infos.city,
            estado: estado,
            pais: infos.country,
            provedora: infos.isp,
            lon: infos.longitude,
            lat: infos.latitude
        })
        Mapa({lon: infos.longitude, lat: infos.latitude})
    }


    useEffect(() => {
        setInfos()
    }, [])

    return (
        <section className="map-info">
            <div className="shadow">
                <div id="map" className="map-container">
                    <div className="pelicula">
                        <div className="pingo"></div>
                    </div>
                </div>

                <div className="info">
                    <div><span>Seu IP é: </span><span className="campo">{state.ip}</span></div>
                    <div><span>Cidade: </span><span className="campo">{state.cidade}</span></div>
                    <div><span>Estado: </span><span className="campo">{state.estado}</span></div>
                    <div><span>País: </span><span className="campo">{state.pais}</span></div>
                    <div><span>Latitude: </span><span className="campo">{state.lat}</span></div>
                    <div><span>Longitude: </span><span className="campo">{state.lon}</span></div>
                    <div><span>Provedora: </span><span className="campo">{state.provedora}</span></div>
                </div>
            </div>
        </section>
    )
}